import React from 'react'
import Header from './Header'
import Footer from './Footer'
import Flash from './Flash'
import PendingApprovalBanner from './PendingApprovalBanner'

export default function Layout({ children, fullWidth = false, noFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Flash />

      <div className="pt-16">
        <PendingApprovalBanner />
      </div>

      <main className={`flex-1 ${fullWidth ? '' : 'container mx-auto px-4 py-8'}`}>
        {children}
      </main>

      {!noFooter && <Footer />}
    </div>
  )
}
